import React, {useState, useEffect, useContext} from "react";
import { Card, Form, Container } from "react-bootstrap";
import DirectionsMapModal from "../../_modals/specific/DirectionsMapModal";
import dynamicData from "../../data/dynamicData.json";
import TimelineComponent from "../common/TimelineComponent"; // ✅ Import TimelineComponent
import { ActivitiesContext } from "../../context/ActivitiesContext";

const ExpandedActivityCard = ({ data }) => {
  const {travelTime, setArrivalTime} = useContext(ActivitiesContext);
  const [arrivalMethod, setArrivalMethod] = useState("");
  const [travelMode, setTravelMode] = useState("");
  const [showTravelQuestionFlight, setShowTravelQuestionFlight] = useState(false);
  const [showTravelQuestionTrain, setShowTravelQuestionTrain] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const [loadDynamicData, setLoadDynamicData] = useState(false);
  const [activities, setActivities] = useState([]); // ✅ Holds dynamically loaded activities

  // Handle arrival method selection
  const handleArrivalMethodChange = (method) => {
    setArrivalMethod(method);
    setTravelMode(""); // Reset travel mode on method change

    if (method === "plane") {
      setShowTravelQuestionFlight(true);
      setShowTravelQuestionTrain(false);
    } else if (method === "train") {
      setShowTravelQuestionTrain(true);
      setShowTravelQuestionFlight(false);
    } else {
      setShowTravelQuestionFlight(false);
      setShowTravelQuestionTrain(false);
    }
  };

  // Handle travel mode selection & Open Map Modal
  const handleTravelModeChange = (mode) => {
    setTravelMode(mode);
    setShowMapModal(true);
  };

  const requestBody = JSON.stringify({
    "budget": 500,
    "daily_config": {
      "0": {
        "end_time": "2025-02-01 19:00",
        "preferences": [
          "Shopping"
        ],
        "start_time": "2025-02-01 13:00"
      },
      "1": {
        "end_time": "2025-02-02 20:00",
        "preferences": [
          "Site Seeing"
        ],
        "start_time": "2025-02-02 09:00"
      },
      "2": {
        "end_time": "2025-02-03 18:00",
        "preferences": [
          "Site Seeing"
        ],
        "start_time": "2025-02-03 10:30"
      }
    },
    "end_date": "2025-02-03",
    "hotel_location": [
      45.4959,
      -73.6206
    ],
    "location": [
      45.4959,
      -73.6206
    ],
    "max_travel_time": 60,
    "radius": 3000,
    "start_date": "2025-02-01"
  })

    const fetchActivities = async () => {
      try {
        const response = await fetch("https://citygetaway-backend-plan-service.vercel.app/api/generate_plan_mulitple", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: requestBody,
        });
        return response.status === 200 ? response.json() : false;
      } catch (error) {
        console.error("Error fetching activities:", error);
        return false;
      }
    }

  // Categorize activities based on the selected time
  const updateItinerary = () => {
    const [time, modifier] = travelTime.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    let promise = fetchActivities();
    promise.then((response) => {
      const multiDayItinerary = response["multi_day_itinerary"];
      if (multiDayItinerary.length > 0) {
        // console.log("Activities fetched successfully:", multiDayItinerary);
        setActivities(multiDayItinerary);
      } else {

        if (modifier === "PM" && hours !== 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;

        if (hours >= 7 && hours < 11) {
          setActivities(dynamicData.items1);
        } else if (hours >= 11 && hours < 16) {
          setActivities(dynamicData.items2);
        } else if (hours >= 16 && hours < 19) {
          setActivities(dynamicData.items3);
        } else if (hours >= 19 && hours <= 22) {
          setActivities(dynamicData.items4);
        } else {
          setActivities([]);
        }
      }
    } ).catch((error) => {
        console.error("Error fetching activities:", error);
    });
  };

  useEffect(() => {
    if (travelTime) {
      updateItinerary();
    }
  }, [travelTime]);


  return (
    <>
      <Card style={{ margin: "0 auto", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }} className="main-active-card">
        <Card.Img variant="top" src={data.image || "../assets/default.jpg"} />
        <Card.Body className="card-body-expanded">
          <Card.Title>{data.name}</Card.Title>
          <Card.Text className="text-muted" style={{ fontSize: "0.9rem" }}>
            <span className="material-icons" style={{ verticalAlign: "middle", fontWeight: "700" }}>
              location_on
            </span>{" "}
            <strong>{data.address}</strong>
            <br />
            <strong>{data.checkIn}</strong>
          </Card.Text>
          <Card.Text style={{ fontSize: "0.9rem", color: "#333" }}>{data.description}</Card.Text>

          <Form>
            <Form.Group controlId="formTravelTime">
              <Form.Label>Expected arrival time:</Form.Label>
              <Form.Control
                type="time"
                // placeholder="Enter your travel time"
                value={travelTime}
                onChange={(e) => {
                  setArrivalTime(e.target.value);
                }}
              />
            </Form.Group>

            <Form.Group controlId="formArrivalMethod" className="mt-3">
              <Form.Label>What is your arrival method?</Form.Label>
              <Form.Check
                type="radio"
                label="Plane at YUL"
                name="arrivalMethod"
                value="plane"
                checked={arrivalMethod === "plane"}
                onChange={() => handleArrivalMethodChange("plane")}
              />
              {showTravelQuestionFlight && (
                <Form.Group controlId="formTravelMode" style={{ paddingLeft: "15px" }}>
                  <Form.Label>How do you want to travel to the next place?</Form.Label>
                  <Form.Check
                    type="radio"
                    label="Uber/Taxi ($40, 20 mins)"
                    name="travelMode"
                    value="uber"
                    checked={travelMode === "uber"}
                    onChange={() => handleTravelModeChange("driving")}
                  />
                  <Form.Check
                    type="radio"
                    label="Bus 747 ($11.50, 40 mins)"
                    name="travelMode"
                    value="bus"
                    checked={travelMode === "bus"}
                    onChange={() => handleTravelModeChange("transit")}
                  />
                  <Form.Check
                    type="radio"
                    label="Rental Car"
                    name="travelMode"
                    value="car"
                    checked={travelMode === "car"}
                    onChange={() => handleTravelModeChange("driving")}
                  />
                </Form.Group>
              )}

              <Form.Check
                type="radio"
                label="Train at Bonaventure"
                name="arrivalMethod"
                value="train"
                checked={arrivalMethod === "train"}
                onChange={() => handleArrivalMethodChange("train")}
              />
              {showTravelQuestionTrain && (
                <Form.Group controlId="formTravelMode" style={{ paddingLeft: "15px" }}>
                  <Form.Label>How do you want to travel to the next place?</Form.Label>
                  <Form.Check
                    type="radio"
                    label="Uber"
                    name="travelMode"
                    value="uber"
                    checked={travelMode === "uber"}
                    onChange={() => handleTravelModeChange("driving")}
                  />
                  <Form.Check
                    type="radio"
                    label="Bus"
                    name="travelMode"
                    value="bus"
                    checked={travelMode === "bus"}
                    onChange={() => handleTravelModeChange("transit")}
                  />
                  <Form.Check
                    type="radio"
                    label="Walking"
                    name="travelMode"
                    value="walking"
                    checked={travelMode === "walking"}
                    onChange={() => handleTravelModeChange("walking")}
                  />
                </Form.Group>
              )}

              <Form.Check
                type="radio"
                label="By car"
                name="arrivalMethod"
                value="car"
                checked={arrivalMethod === "driving"}
                onChange={() => {
                  handleArrivalMethodChange("driving");
                  handleTravelModeChange("driving");
                }}
              />
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>

      {/* ✅ Show Timeline Below First Activity When Data is Loaded */}
      {activities.length > 0 && loadDynamicData && (
        <Container className="mt-4">
          <TimelineComponent activities={activities} removedActivities={[]} newActivities={[]} />
        </Container>
      )}

      {/* ✅ DirectionsMapModal */}
      <DirectionsMapModal
        show={showMapModal}
        onHide={() => setShowMapModal(false)}
        travelMode={travelMode}
        arrivalMode={arrivalMethod}
      />
    </>
  );
};

export default ExpandedActivityCard;